<template>
  <div>
    <a href="#" v-for="exampleImage in exampleImages" v-on:click.prevent="$emit('picked', exampleImage)" v-bind:class="['example-image-button', `example-image-button-${theme}`]" ondragstart="return false;">
      <img v-bind:src="exampleImage.thumbnail_url" alt="Example image" class="img-fluid rounded example-image" />
    </a>
  </div>
</template>

<script>
import { useUploaderSamples } from "../composables/uploader_samples";

export default {
  mounted() {
    this.setExampleImages();
  },
  props: {
    theme: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {
      exampleImages: [],
    };
  },
  methods: {
    setExampleImages() {
      const { availableImages } = useUploaderSamples();

      for (var i = 0; i < availableImages.length; i++) {
        var category = availableImages[i];
        var n = Math.floor(Math.random() * category.length);
        this.exampleImages.push(category[n]);
      }
    },
  },
};
</script>

<style scoped>
.example-image-button {
  display: inline-block;
  opacity: 1;
}
.example-image-button:hover {
  opacity: 0.8;
}

/* DEFAULT */
.example-image-button-default {
  margin: 0 5px;
}
.example-image-button-default .example-image {
  max-width: 60px;
}

/* SMALL */
.example-image-button-small {
  margin: 0 2px;
}
.example-image-button-small .example-image {
  max-width: 40px;
}
</style>
